import type { Content } from '@cobliteam/prismic';
import type { FeatureFlags } from '../../useFeatureFlags';
import { matchesPrismicFeatureFlags, type PrismicFeatureFlagEntry } from '../../useFeatureFlags/prismicFeatureFlags';

/**
 * `feature_flags` is authored on the `news` custom type in Prismic and mirrors the group already used
 * by `announcement_card`. The generated Prismic types trail the content model, so the group is read
 * defensively: documents without it stay public.
 */
type NewsDataWithFeatureFlags = { feature_flags?: PrismicFeatureFlagEntry[] };

export const getNewsFeatureFlagEntries = (document: Content.NewsDocument): PrismicFeatureFlagEntry[] => (document.data as NewsDataWithFeatureFlags).feature_flags ?? [];

/** Keeps only the news items the current fleet/user is allowed to see. */
export const filterNewsByFeatureFlags = (documents: readonly Content.NewsDocument[], flags: Partial<FeatureFlags> | null | undefined): Content.NewsDocument[] =>
  documents.filter((document) => matchesPrismicFeatureFlags(getNewsFeatureFlagEntries(document), flags));
